export default "__VITE_ASSET__BLgjNO4w__"